module.exports = __webpack_public_path__ + "static/media/img_d_clock@3x.2fca7cfb.png";